import React, { useCallback, useEffect, useState } from "react";
import { Button, Flex, Modal, Table, Typography } from "antd";

import BusinessNumbersHeader from "../../../components/whatsapp/BusinessNumbersHeader";
import { useDispatch } from "react-redux";
import { fetchWhatsappNumbers } from "../../../../../reduxToolkit/channelSlice";
import { SettingOutlined } from "@ant-design/icons";
import {
  daily_messaging_limit,
  quality_rating,
  statusKeys,
} from "../../../../../modules/channels/constant/phoneNumbers";

import { useSelector } from "react-redux";
import BusinessNumberAction from "./BusinessNumberAction";
import SignalStrength from "./SignalStrength";
const { Text } = Typography;

const index = () => {
  const dispatch = useDispatch();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProfileInfo, setSelectedProfileInfo] = useState(null);

  const {
    whatsappBusinessNumbersListLoading,
    updateBusinessProfileLoading,
    wapNumbersListBrandId,
    metaAssetHandlerLoading,
    updateBusinessProfileError,
    whatsappBusinessNumbersList: { wapp_business_num, wapp_business_num_count },
  } = useSelector((store) => store.Channel);
  const { currentBrand } = useSelector((state) => state.app);
  const brandId = currentBrand?.brand_id;

  const showModal = (id) => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    if (!wapp_business_num?.length) dispatch(fetchWhatsappNumbers(brandId));
    else if (
      wapp_business_num?.length !== 0 &&
      wapNumbersListBrandId !== brandId
    ) {
      dispatch(fetchWhatsappNumbers(brandId));
    }
  }, [brandId]);

  const fetchMoreData = useCallback(() => {
    if (whatsappBusinessNumbersListLoading) return;
    // TODO: Fetch more data
  }, [wapp_business_num?.length]);

  const handleTableScroll = (e) => {
    const { scrollTop, clientHeight, scrollHeight } = e.target;
    if (scrollHeight - scrollTop <= clientHeight + 1) {
      console.log("Reached bottom, fetching more data...");
      fetchMoreData();
    }
  };

  const columns = [
    {
      title: <Text className="text-[#616874] text-xs">Phone Number</Text>,
      dataIndex: "send_from_phone_number",
      key: "send_from_phone_number",
      width: 150,
      render: (text, record) => (
        <Text className="text-[#2D3036] text-xs">
          {`(+${record.country_code}) ${text.slice(0, 3)} 
          ${text.slice(3, 6)} ${text.slice(6)}`}
        </Text>
      ),
    },

    {
      title: <Text className="text-[#616874] text-xs">Display Name</Text>,
      dataIndex: "send_from_phone_name",
      key: "send_from_phone_name",
      width: 200,
      render: (text) => <Text className="text-[#2D3036] text-xs">{text}</Text>,
    },

    {
      title: <Text className="text-[#616874] text-xs">Status</Text>,
      dataIndex: "status",
      key: "status",
      width: 150,
      render: (text) => {
        const statusKey = statusKeys[text];
        return (
          <Flex
            align="center"
            justify="center"
            className="border-[1px] rounded-[.3rem] max-w-max px-2 py-[3px]"
            style={{
              borderColor: statusKey?.text || "#25C277",
              backgroundColor: statusKey?.backgroundColor || "#EEFBF4",
            }}
          >
            <Text
              className="text-xs"
              style={{ color: statusKey?.text || "#25C277" }}
            >
              {statusKey?.label || text}
            </Text>
          </Flex>
        );
      },
    },

    {
      title: <Text className="text-[#616874] text-xs">Quality Rating</Text>,
      dataIndex: "quality_rating",
      key: "quality_rating",
      width: 150,
      render: (text) => (
        <Flex gap={6} size="small" align="center">
          <div className="size-4">
            <SignalStrength level={quality_rating[text]?.toUpperCase()} />
          </div>
          <Text className="text-[#2D3036] text-xs">{quality_rating[text]}</Text>
        </Flex>
      ),
    },

    {
      title: <Text className="text-[#616874] text-xs">Messaging Limit</Text>,
      dataIndex: "daily_messaging_limit",
      key: "daily_messaging_limit",
      width: 150,
      render: (text) => (
        <div className="min-w-[70px]">
          <Text className="text-[#2D3036] text-xs">
            {daily_messaging_limit[text]}{" "}
            {daily_messaging_limit[text] !== "Unavailable" ? "/ Day" : ""}
          </Text>
        </div>
      ),
    },

    {
      title: <Text className="text-[#616874] text-xs">Country</Text>,
      dataIndex: "country_name",
      key: "country_name",
      width: 100,
      render: (text) => <Text className="text-[#2D3036] text-xs">{text}</Text>,
    },

    {
      title: <Text className="text-[#616874] text-xs">Actions</Text>,
      key: "actions",
      align: "center",
      width: 100,
      render: (_, record) => {
        return (
          <>
            <Button
              type="text"
              icon={<SettingOutlined />}
              loading={updateBusinessProfileLoading}
              disabled={updateBusinessProfileLoading}
              onClick={() => {
                if (updateBusinessProfileLoading) return;
                setSelectedProfileInfo({
                  ...record.profile_info,
                  profile_name: record.send_from_phone_name,
                  phone_number_id: record.send_from_phone_number_id,
                });
                setIsModalOpen(true);
              }}
            />
          </>
        );
      },
    },
  ];

  const handleProfileUpdateSuccess = () => {
    setIsModalOpen(false);
    setSelectedProfileInfo(null);
  };

  return (
    <div className="h-full">
      <BusinessNumbersHeader
        onSync={() => {
          dispatch(fetchWhatsappNumbers(brandId));
        }}
      />
      <Modal
        title="Profile Information"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={() => {
          if (!updateBusinessProfileLoading) handleCancel();
        }}
        destroyOnClose
        width={600}
        centered
        confirmLoading={updateBusinessProfileLoading || metaAssetHandlerLoading}
        onClose={() => {
          if (!updateBusinessProfileLoading) {
            setSelectedProfileInfo(null);
            handleCancel();
          }
        }}
        footer={null}
        okText="Edit Profile Info"
      >
        <BusinessNumberAction
          // onCancel={handleCancel}
          // onSubmit={handleOk}
          about={selectedProfileInfo?.about}
          email={selectedProfileInfo?.email}
          address={selectedProfileInfo?.address}
          description={selectedProfileInfo?.description}
          vertical={selectedProfileInfo?.vertical}
          websites={selectedProfileInfo?.websites}
          profile_picture_url={selectedProfileInfo?.profile_picture_url}
          profile_name={selectedProfileInfo?.profile_name}
          phone_number_id={selectedProfileInfo?.phone_number_id}
          onSuccess={handleProfileUpdateSuccess}
        />
      </Modal>
      <div className="flex-1 w-full p-4 bg-white rounded-lg transition-all duration-300 ease-in-out mt-4">
        <Table
          columns={columns}
          dataSource={wapp_business_num}
          pagination={false}
          bordered={false}
          showHeader={true}
          loading={whatsappBusinessNumbersListLoading}
          disabled={whatsappBusinessNumbersListLoading}
          scroll={{
            y: "65vh",
            x: "max-content",
          }}
          onScroll={handleTableScroll}
          className="custom-table w-full transition-all duration-300"
          style={{ minWidth: "100%" }}
        />
      </div>
    </div>
  );
};

export default index;
